import React from 'react';
import SecondStageHeader from '../components/second_stage_header';
import OnboardInfo from '../components/onboard_info';
import CardsContainer from '../containers/cards_container';
import styles from './styles';

function SecondStageSection() {
  return (
    <>
      <SecondStageHeader />
      <CardsContainer lg={12} sm={12} direction='column' style={styles.cardContainer}>
        <OnboardInfo />
      </CardsContainer>
    </>
  );
}

export default SecondStageSection;
